// src/encounter/ap-med-stop-host.tsx
//
// `medActions`: the A&P Active Medications "Discontinue" is today's Stop: the rail's confirm (IpsMedStopDialog) and the same save
// (useSaveMedication `stop` → PostStopMedication). A component of its own, mounted only while it is open, so the encounter page
// itself never needs a query client for it (its test harnesses render with none), as RecordingConsentHost does.
import { IpsMedStopDialog } from './ips-med-stop-dialog';
import { useSaveMedication } from './services/use-save-medication';
import { showServerError } from '@/shared/lib/toast-helpers';

export function ApMedStopHost({
  patientId,
  identifier,
  display,
  onClose,
}: {
  patientId: string | undefined;
  /** The chart medication's identifier (the record the rail's Stop stops). */
  identifier: string;
  display: string;
  onClose: () => void;
}) {
  const save = useSaveMedication(patientId);
  return (
    <IpsMedStopDialog
      open
      medication={display}
      saving={save.isPending}
      // Closes on success only: while the stop saves the dialog shows it, and a failed stop says so and stays open (#906 review).
      onConfirm={(value) =>
        save.mutate(
          { kind: 'stop', identifier, ...value },
          { onSuccess: onClose, onError: (err) => showServerError('Stop medication', err) },
        )
      }
      onClose={onClose}
    />
  );
}
